import { render, staticRenderFns } from "./EditPopupBanner.vue?vue&type=template&id=8548a62e"
import script from "./EditPopupBanner.vue?vue&type=script&lang=js"
export * from "./EditPopupBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports